// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_bded9b2f {
  margin: 0;
  padding: 0;
  border: 0;
  position: relative;
  display: inline-block;
  background: none;
  overflow: visible;
  border-radius: 0.167em;
  height: 2.667rem;
  touch-action: manipulation;
  text-align: center;
  color: #11304d;
  transition: all 0.3s;
  transition-property: background-color, border-color, color;
  cursor: pointer;
  text-transform: none;
  font-weight: 600;
}
button.button_bded9b2f {
  -webkit-appearance: button;
}
.button_circled_bded9b2f {
  border-radius: 1.3335rem;
}
.button__hole_bded9b2f {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}
.button__caption_bded9b2f {
  position: relative;
  flex-grow: 1;
  flex-basis: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.button__caption_bded9b2f:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.button__caption_bded9b2f:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.button__icon_bded9b2f {
  margin-right: 0.667rem;
  position: relative;
  line-height: 1;
  white-space: nowrap;
  display: inline-flex;
}
.button__icon_flat_bded9b2f {
  min-width: 1.5rem;
  justify-content: center;
}
.button__icon_right_bded9b2f {
  margin-right: 0;
  margin-left: 0.667rem;
}
.button__icon_busy_bded9b2f {
  opacity: 0;
}
.button_bded9b2f:disabled {
  color: #c1c8cd;
  cursor: default;
}
.button_flat_bded9b2f:hover .button__caption_bded9b2f,
.button_flat_bded9b2f.button_active_bded9b2f .button__caption_bded9b2f,
.button_flat_bded9b2f:active .button__caption_bded9b2f {
  text-decoration: underline;
}
.button_flat_bded9b2f .button__icon_bded9b2f {
  margin-right: 0.667rem;
}
.button_flat_bded9b2f .button__icon_right_bded9b2f {
  margin-right: 0;
  margin-left: 0.667rem;
}
.button_flat_bded9b2f:disabled {
  background-color: transparent !important;
  color: #c1c8cd;
  text-shadow: none !important;
  box-shadow: none !important;
}
.button_flat_bded9b2f:disabled .button__caption_bded9b2f {
  text-decoration: none !important;
}
.button_pagination_bded9b2f:disabled {
  background-color: transparent !important;
  color: #c1c8cd !important;
  text-shadow: none !important;
  box-shadow: none !important;
}
.button_pagination_bded9b2f:disabled .button__caption_bded9b2f {
  text-decoration: none !important;
}
.button_back_bded9b2f {
  padding-left: 1.334rem;
  padding-right: 1.334rem;
  display: block;
  width: 100%;
  height: 56px;
  line-height: 56px;
  text-align: left;
}
.button_back_bded9b2f .button__icon_bded9b2f {
  width: 2.667rem;
  margin-right: 1.334rem;
  text-align: center;
  font-size: 1.584rem;
}
.button_small_bded9b2f {
  height: 2rem;
}
.button__busy_bded9b2f {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button__busy_bded9b2f span {
  background-color: #a3adb4;
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border-radius: 50%;
  margin: 0 0.167rem;
  transform: scale3d(1, 1, 1);
  animation-name: button-loader_bded9b2f;
  animation-duration: 1250ms;
  animation-iteration-count: infinite;
}
.button__busy_1_bded9b2f {
  animation-delay: 0ms;
}
.button__busy_2_bded9b2f {
  animation-delay: 325ms;
}
.button__busy_3_bded9b2f {
  animation-delay: 750ms;
}
.button_primary_bded9b2f:hover {
  text-decoration: none;
}
.button_primary_bded9b2f {
  padding-left: 1.334rem;
  padding-right: 1.334rem;
  background-color: var(--button-background-color, #1d5080);
  color: var(--button-color, #fff);
  box-shadow: inset 0 -0.166rem 0 0 var(--button-box-shadow-color, rgba(0,0,0,0.3));
  line-height: 2.5rem;
}
.button_primary_bded9b2f.button_dark-mode_bded9b2f {
  padding-left: 1.334rem;
  padding-right: 1.334rem;
  background-color: var(--button-background-color, #fff);
  color: var(--button-color, #11304d);
  box-shadow: inset 0 -0.166rem 0 0 var(--button-box-shadow-color, rgba(0,0,0,0.3));
  line-height: 2.5rem;
}
.button_primary_bded9b2f:hover {
  background-color: var(--button-background-color-hover, #26649e);
  color: var(--button-color, #fff);
}
.button_primary_bded9b2f:hover.button_dark-mode_bded9b2f {
  background-color: var(--button-background-color-hover, #eaedef);
  color: var(--button-color, #11304d);
}
.button_primary_bded9b2f:active,
.button_primary_bded9b2f.button_active_bded9b2f {
  background-color: var(--button-background-color-active, #1d5080);
  color: var(--button-color, #fff);
  box-shadow: inset 0 0.167rem 0 0 var(--button-box-shadow-color, rgba(0,0,0,0.3));
}
.button_primary_bded9b2f:active.button_dark-mode_bded9b2f,
.button_primary_bded9b2f.button_active_bded9b2f.button_dark-mode_bded9b2f {
  background-color: var(--button-background-color-active, #fff);
  color: var(--button-color, #11304d);
  box-shadow: inset 0 0.167rem 0 0 var(--button-box-shadow-color, rgba(0,0,0,0.3));
}
.button_primary_bded9b2f:disabled {
  color: #c1c8cd;
  background-color: #eaedef;
}
.button_primary_bded9b2f:disabled.button_dark-mode_bded9b2f {
  color: #1d5080;
  background-color: #0f345c;
}
.button_primary_bded9b2f.button_error_bded9b2f {
  --button-background-color: #b32700;
  --button-background-color-hover: #801c00;
  --button-background-color-active: #730008;
  --button-color: #fff;
  --button-box-shadow-color: rgba(0,0,0,0.3);
  --busy-state-background-color: #fff;
}
.button_primary_bded9b2f.button_error_bded9b2f.button_dark-mode_bded9b2f {
  --button-background-color: #b32700;
  --button-background-color-hover: #801c00;
  --button-background-color-active: #730008;
  --button-color: #fff;
  --button-box-shadow-color: rgba(0,0,0,0.3);
  --busy-state-background-color: #fff;
}
.button_primary_bded9b2f.button_accent_bded9b2f {
  --button-background-color: #267479;
  --button-background-color-hover: #206165;
  --button-background-color-active: #1a4f52;
  --button-color: #fff;
  --button-box-shadow-color: rgba(0,0,0,0.3);
  --busy-state-background-color: #fff;
}
.button_primary_bded9b2f.button_accent_bded9b2f.button_dark-mode_bded9b2f {
  --button-background-color: #267479;
  --button-background-color-hover: #206165;
  --button-background-color-active: #1a4f52;
  --button-color: #fff;
  --button-box-shadow-color: rgba(0,0,0,0.3);
  --busy-state-background-color: #fff;
}
.button_primary_bded9b2f.button_busy_bded9b2f {
  --busy-background-color: var(--busy-state-background-color, #fff);
}
.button_primary_bded9b2f.button_busy_bded9b2f.button_dark-mode_bded9b2f {
  --busy-background-color: var(--busy-state-background-color, #657682);
}
.button_primary_bded9b2f.button_busy_bded9b2f .button__hole_bded9b2f {
  opacity: 0;
  pointer-events: none;
}
.button_primary_bded9b2f:disabled {
  background-color: #eaedef;
  color: #c1c8cd;
  box-shadow: none;
  cursor: default;
  border-color: transparent;
}
.button_secondary_bded9b2f:hover {
  text-decoration: none;
}
.button_secondary_bded9b2f {
  padding-left: 1.334rem;
  padding-right: 1.334rem;
  background-color: var(--button-background-color, #fff);
  color: var(--button-color, #11304d);
  border: solid 0.084rem var(--button-border-color, #11304d);
  line-height: 2.5rem;
}
.button_secondary_bded9b2f.button_dark-mode_bded9b2f {
  padding-left: 1.334rem;
  padding-right: 1.334rem;
  background-color: var(--button-background-color, transparent);
  color: var(--button-color, #fff);
  border: solid 0.084rem var(--button-border-color, #fff);
  line-height: 2.5rem;
}
.button_secondary_bded9b2f:hover {
  color: var(--button-color-hover, #fff);
  background-color: var(--button-background-color-hover, #11304d);
  border-color: var(--button-border-color-hover, #11304d);
}
.button_secondary_bded9b2f:hover.button_dark-mode_bded9b2f {
  color: var(--button-color-hover, #11304d);
  background-color: var(--button-background-color-hover, #eaedef);
  border-color: var(--button-border-color-hover, #eaedef);
}
.button_secondary_bded9b2f.button_focus_bded9b2f {
  color: var(--button-color-hover, #fff);
  background-color: var(--button-background-color-hover, #11304d);
  border-color: var(--button-border-color-hover, #11304d);
}
.button_secondary_bded9b2f.button_focus_bded9b2f.button_dark-mode_bded9b2f {
  color: var(--button-color-hover, #11304d);
  background-color: var(--button-background-color-hover, #eaedef);
  border-color: var(--button-border-color-hover, #eaedef);
}
.button_secondary_bded9b2f:active,
.button_secondary_bded9b2f.button_active_bded9b2f {
  color: var(--button-color-active, #fff);
  background-color: var(--button-background-color-active, #051c38);
  border-color: var(--button-border-color-active, #11304d);
}
.button_secondary_bded9b2f:active.button_dark-mode_bded9b2f,
.button_secondary_bded9b2f.button_active_bded9b2f.button_dark-mode_bded9b2f {
  color: var(--button-color-active, #11304d);
  background-color: var(--button-background-color-active, #dce1e5);
  border-color: var(--button-border-color-active, #dce1e5);
}
.button_secondary_bded9b2f:disabled {
  color: #c1c8cd;
  background-color: #eaedef;
}
.button_secondary_bded9b2f:disabled.button_dark-mode_bded9b2f {
  color: #1d5080;
  background-color: #0f345c;
}
.button_secondary_bded9b2f.button_error_bded9b2f {
  --button-background-color: #fff;
  --button-background-color-hover: #fee0d0;
  --button-background-color-active: #ffaf99;
  --button-color: #b32700;
  --button-color-hover: #b32700;
  --button-color-active: #730008;
  --button-border-color: #b32700;
  --button-border-color-hover: #b32700;
  --button-border-color-active: #730008;
  --busy-state-background-color: #657682;
}
.button_secondary_bded9b2f.button_error_bded9b2f.button_dark-mode_bded9b2f {
  --button-background-color: transparent;
  --button-background-color-hover: #fee0d0;
  --button-background-color-active: #ffaf99;
  --button-color: #ffaf99;
  --button-color-hover: #b32700;
  --button-color-active: #b32700;
  --button-border-color: #ffaf99;
  --button-border-color-hover: #b32700;
  --button-border-color-active: #b32700;
  --busy-state-background-color: #fff;
}
.button_secondary_bded9b2f.button_accent_bded9b2f {
  --button-background-color: #fff;
  --button-background-color-hover: #e3f4f4;
  --button-background-color-active: #c4edeb;
  --button-color: #267479;
  --button-color-hover: #267479;
  --button-color-active: #1a4f52;
  --button-border-color: #267479;
  --button-border-color-hover: #267479;
  --button-border-color-active: #1a4f52;
  --busy-state-background-color: #657682;
}
.button_secondary_bded9b2f.button_accent_bded9b2f.button_dark-mode_bded9b2f {
  --button-background-color: transparent;
  --button-background-color-hover: #e3f4f4;
  --button-background-color-active: #c4edeb;
  --button-color: #e3f4f4;
  --button-color-hover: #267479;
  --button-color-active: #267479;
  --button-border-color: #e3f4f4;
  --button-border-color-hover: #267479;
  --button-border-color-active: #267479;
  --busy-state-background-color: #fff;
}
.button_secondary_bded9b2f.button_busy_bded9b2f {
  --busy-background-color: var(--busy-state-background-color, #657682);
}
.button_secondary_bded9b2f.button_busy_bded9b2f.button_dark-mode_bded9b2f {
  --busy-background-color: var(--busy-state-background-color, #fff);
}
.button_secondary_bded9b2f.button_busy_bded9b2f .button__hole_bded9b2f {
  opacity: 0;
  pointer-events: none;
}
.button_secondary_bded9b2f:disabled {
  background-color: #eaedef;
  color: #c1c8cd;
  box-shadow: none;
  cursor: default;
  border-color: transparent;
}
.button_tertiary_bded9b2f:hover {
  text-decoration: none;
}
.button_tertiary_bded9b2f {
  padding-left: 1.334rem;
  padding-right: 1.334rem;
  background-color: #eaedef;
  color: var(--button-color, #11304d);
  border: solid 0.084rem #c1c8cd;
  line-height: 2.5rem;
}
.button_tertiary_bded9b2f.button_dark-mode_bded9b2f {
  padding-left: 1.334rem;
  padding-right: 1.334rem;
  background-color: #0f345c;
  color: var(--button-color, #fff);
  border: solid 0.084rem #26649e;
  line-height: 2.5rem;
}
.button_tertiary_bded9b2f:hover {
  background-color: #dce1e5;
  color: var(--button-color-hover, #11304d);
}
.button_tertiary_bded9b2f:hover.button_dark-mode_bded9b2f {
  background-color: #11304d;
  color: var(--button-color-hover, #fff);
  border: solid 0.084rem #26649e;
}
.button_tertiary_bded9b2f.button_focus_bded9b2f {
  background-color: #dce1e5;
  color: var(--button-color-hover, #11304d);
}
.button_tertiary_bded9b2f.button_focus_bded9b2f.button_dark-mode_bded9b2f {
  background-color: #11304d;
  color: var(--button-color-hover, #fff);
  border: solid 0.084rem #26649e;
}
.button_tertiary_bded9b2f:active,
.button_tertiary_bded9b2f.button_active_bded9b2f {
  background-color: #c1c8cd;
  color: var(--button-color-hover, #11304d);
}
.button_tertiary_bded9b2f:active.button_dark-mode_bded9b2f,
.button_tertiary_bded9b2f.button_active_bded9b2f.button_dark-mode_bded9b2f {
  background-color: #051c38;
  color: var(--button-color-hover, #fff);
  border: solid 0.084rem #26649e;
}
.button_tertiary_bded9b2f:disabled {
  color: #c1c8cd;
  background-color: #eaedef;
}
.button_tertiary_bded9b2f:disabled.button_dark-mode_bded9b2f {
  color: #1d5080;
  background-color: #0f345c;
}
.button_tertiary_bded9b2f.button_busy_bded9b2f {
  --busy-background-color: var(--busy-state-background-color, #657682);
}
.button_tertiary_bded9b2f.button_busy_bded9b2f.button_dark-mode_bded9b2f {
  --busy-background-color: var(--busy-state-background-color, #fff);
}
.button_tertiary_bded9b2f.button_busy_bded9b2f .button__hole_bded9b2f {
  opacity: 0;
  pointer-events: none;
}
.button_tertiary_bded9b2f:disabled {
  background-color: #eaedef;
  color: #c1c8cd;
  box-shadow: none;
  cursor: default;
  border-color: transparent;
}
.button_flat_bded9b2f:hover {
  text-decoration: none;
}
.button_flat_bded9b2f {
  height: auto;
  color: #26649e;
}
.button_flat_bded9b2f.button_dark-mode_bded9b2f {
  height: auto;
  color: #fff;
}
.button_flat_bded9b2f:hover {
  color: #267479;
}
.button_flat_bded9b2f:hover.button_dark-mode_bded9b2f {
  color: #c4edeb;
}
.button_flat_bded9b2f.button_focus_bded9b2f {
  color: #267479;
}
.button_flat_bded9b2f.button_focus_bded9b2f.button_dark-mode_bded9b2f {
  color: #c4edeb;
}
.button_flat_bded9b2f:active,
.button_flat_bded9b2f.button_active_bded9b2f {
  color: #1a4f52;
}
.button_flat_bded9b2f:active.button_dark-mode_bded9b2f,
.button_flat_bded9b2f.button_active_bded9b2f.button_dark-mode_bded9b2f {
  color: #40c2c9;
}
.button_flat_bded9b2f:disabled {
  color: #c1c8cd;
}
.button_flat_bded9b2f:disabled.button_dark-mode_bded9b2f {
  color: #6185a6;
}
.button_flat_bded9b2f:disabled {
  background-color: #eaedef;
  color: #c1c8cd;
  box-shadow: none;
  cursor: default;
  border-color: transparent;
}
.button_pagination_bded9b2f:hover {
  text-decoration: none;
}
.button_pagination_bded9b2f {
  padding-left: 0.667rem;
  padding-right: 0.667rem;
  min-width: 2.667rem;
  color: #26649e;
  border: solid 0.084rem transparent;
  background-color: transparent;
  transition: none;
  font-weight: 400;
}
.button_pagination_bded9b2f:hover {
  background-color: #dce1e5;
  color: #0f345c;
  border-color: #c1c8cd;
}
.button_pagination_bded9b2f.button_focus_bded9b2f {
  background-color: #dce1e5 !important;
  color: #0f345c !important;
  border-color: #c1c8cd !important;
}
.button_pagination_bded9b2f:active,
.button_pagination_bded9b2f.button_active_bded9b2f {
  background-color: #c1c8cd;
  border-color: #c1c8cd;
  color: #0f345c;
}
.button_pagination_bded9b2f.button_current_bded9b2f {
  background-color: #eaedef;
  border-color: #eaedef;
  color: #0f345c;
  cursor: default;
}
.button_pagination_bded9b2f.button_busy_bded9b2f .button__hole_bded9b2f {
  opacity: 0;
  pointer-events: none;
}
.button_pagination_bded9b2f:disabled {
  background-color: #eaedef;
  color: #c1c8cd;
  box-shadow: none;
  cursor: default;
  border-color: transparent;
}
.button_back_bded9b2f:hover {
  text-decoration: none;
}
.button_back_bded9b2f {
  background-color: #657682;
  color: #fff;
  opacity: 0.8;
}
.button_back_bded9b2f:hover {
  background-color: #051c38;
  color: #fff;
  opacity: 1;
}
.button_back_bded9b2f.button_focus_bded9b2f {
  background-color: #051c38;
  color: #fff;
  opacity: 1;
}
.button_back_bded9b2f:active,
.button_back_bded9b2f.button_active_bded9b2f {
  background-color: #11304d;
  opacity: 1;
  color: #fff;
  font-weight: 600;
}
.button_back_bded9b2f.button_busy_bded9b2f .button__hole_bded9b2f {
  opacity: 0;
  pointer-events: none;
}
.button_back_bded9b2f:disabled {
  background-color: #eaedef;
  color: #c1c8cd;
  box-shadow: none;
  cursor: default;
  border-color: transparent;
}
.button_bded9b2f.button_bded9b2f.button_bded9b2f:focus-visible {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
@-moz-keyframes button-loader_bded9b2f {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.5, 1.5, 1.5);
    background-color: var(--busy-background-color);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@-webkit-keyframes button-loader_bded9b2f {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.5, 1.5, 1.5);
    background-color: var(--busy-background-color);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@-o-keyframes button-loader_bded9b2f {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.5, 1.5, 1.5);
    background-color: var(--busy-background-color);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@keyframes button-loader_bded9b2f {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.5, 1.5, 1.5);
    background-color: var(--busy-background-color);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_bded9b2f`,
	"button_circled": `button_circled_bded9b2f`,
	"button__hole": `button__hole_bded9b2f`,
	"button__caption": `button__caption_bded9b2f`,
	"button__icon": `button__icon_bded9b2f`,
	"button__icon_flat": `button__icon_flat_bded9b2f`,
	"button__icon_right": `button__icon_right_bded9b2f`,
	"button__icon_busy": `button__icon_busy_bded9b2f`,
	"button_flat": `button_flat_bded9b2f`,
	"button_active": `button_active_bded9b2f`,
	"button_pagination": `button_pagination_bded9b2f`,
	"button_back": `button_back_bded9b2f`,
	"button_small": `button_small_bded9b2f`,
	"button__busy": `button__busy_bded9b2f`,
	"button-loader": `button-loader_bded9b2f`,
	"button__busy_1": `button__busy_1_bded9b2f`,
	"button__busy_2": `button__busy_2_bded9b2f`,
	"button__busy_3": `button__busy_3_bded9b2f`,
	"button_primary": `button_primary_bded9b2f`,
	"button_dark-mode": `button_dark-mode_bded9b2f`,
	"button_error": `button_error_bded9b2f`,
	"button_accent": `button_accent_bded9b2f`,
	"button_busy": `button_busy_bded9b2f`,
	"button_secondary": `button_secondary_bded9b2f`,
	"button_focus": `button_focus_bded9b2f`,
	"button_tertiary": `button_tertiary_bded9b2f`,
	"button_current": `button_current_bded9b2f`
};
export default ___CSS_LOADER_EXPORT___;
